var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 27C9.6 27 8.25 28.35 8.25 30C8.25 31.65 9.6 33 11.25 33C12.9 33 14.25 31.65 14.25 30C14.25 28.35 12.9 27 11.25 27ZM2.25 6H5.25L10.65 17.4L8.55 21C8.4 21.45 8.25 22.05 8.25 22.5C8.25 24.15 9.6 25.5 11.25 25.5H29.25V22.5H11.85C11.7 22.5 11.55 22.35 11.55 22.2V22.05L12.9 19.5H24C25.2 19.5 26.1 18.9 26.55 18L31.95 8.25C32.25 7.95 32.25 7.8 32.25 7.5C32.25 6.6 31.65 6 30.75 6H8.55L7.95 4.65C7.5 3.75 6.45 3 5.25 3H2.25V6ZM26.25 27C24.6 27 23.25 28.35 23.25 30C23.25 31.65 24.6 33 26.25 33C27.9 33 29.25 31.65 29.25 30C29.25 28.35 27.9 27 26.25 27Z",
    fill: "#5F6368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartSvg);
export default __webpack_public_path__ + "static/media/cartSvg.a30d0907c47966cc4697174a9abc51f1.svg";
export { ForwardRef as ReactComponent };